/* Waldbrand-Kollektion, Premium-Familie (waldbrand-d / -e / -f): Bewegung und Bedienung.
   Additiv: Ohne dieses Skript steht jede Seite fertig da. Hier werden nur Klassen gesetzt,
   die Keyframes ausloesen, Zahlen hochgezaehlt, Bilder leicht verschoben, Nebel gezeichnet,
   Reiter umgeschaltet, gerechnet und in den Warenkorb gelegt.
   Bei prefers-reduced-motion bleibt alles ruhig; Reiter, Rechner und Warenkorb funktionieren. */
(function () {
  if (window.__wbpBewegung) return;
  window.__wbpBewegung = true;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var feinzeiger = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hatIO = 'IntersectionObserver' in window;
  document.documentElement.classList.add('wbp-js');

  function alle(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function klemme(v, a, b) { return Math.min(b, Math.max(a, v)); }
  var zahlFormat = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function euro(betrag) { return zahlFormat.format(betrag) + ' €'; }
  function ganz(n) { return Math.round(n).toLocaleString('de-DE'); }

  /* 1 Einblenden beim Scrollen: Klasse startet Keyframes, Ruhezustand ist sichtbar */
  alle('[data-wbp-staffel]').forEach(function (el) {
    Array.prototype.forEach.call(el.children, function (k, i) { k.style.setProperty('--wbp-i', Math.min(i, 9)); });
  });
  if (!ruhig && hatIO) {
    var ein = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('wbp-an'); ein.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 6% 0px', threshold: 0 });
    alle('[data-wbp-rv],[data-wbp-staffel]').forEach(function (el) {
      /* Was beim Laden schon im Bild steht, animiert sofort mit (kein Aufblitzen) */
      ein.observe(el);
    });
  }

  /* 2 Zahlen zaehlen hoch. Endwert steht im DOM, Animation nur darueber. */
  function zaehle(el) {
    var roh = el.getAttribute('data-wbp-zahl');
    var ziel = parseFloat(roh);
    if (isNaN(ziel)) return;
    var nk = (roh.split('.')[1] || '').length;
    var endtext = el.textContent;
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    var start = null, dauer = 1600;
    function schritt(t) {
      if (!start) start = t;
      var p = klemme((t - start) / dauer, 0, 1);
      var e = 1 - Math.pow(2, -10 * p);
      el.textContent = (ziel * (p === 1 ? 1 : e)).toLocaleString('de-DE', { minimumFractionDigits: nk, maximumFractionDigits: nk });
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endtext;
    }
    requestAnimationFrame(schritt);
  }
  if (!ruhig && hatIO) {
    var zo = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) { zaehle(e.target); zo.unobserve(e.target); } });
    }, { threshold: 0.6 });
    alle('[data-wbp-zahl]').forEach(function (el) { zo.observe(el); });
  }

  /* 3 Sichtbarkeit fuer Dauerschleifen: laufen nur, solange sie im Bild sind */
  if (hatIO) {
    var so = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('wbp-sicht', e.isIntersecting && !ruhig); });
    }, { threshold: 0.05 });
    alle('[data-wbp-sicht]').forEach(function (el) { so.observe(el); });
  }

  /* 4 Tiefe (Parallaxe) und Scroll-Fortschritt, ein gemeinsamer rAF-Takt */
  var tiefe = alle('[data-wbp-tiefe]');
  var fortschritt = alle('[data-wbp-fortschritt]');
  var tickt = false;
  function takt() {
    tickt = false;
    var vh = window.innerHeight;
    if (!ruhig) {
      tiefe.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var f = parseFloat(el.getAttribute('data-wbp-tiefe')) || 0.1;
        var mitte = r.top + r.height / 2 - vh / 2;
        var grenze = r.height * 0.07;
        el.style.setProperty('--wbp-py', klemme(mitte * -f, -grenze, grenze).toFixed(1) + 'px');
      });
    }
    fortschritt.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = klemme((vh * 0.55 - r.top) / Math.max(r.height - vh * 0.3, 1), 0, 1);
      el.style.setProperty('--wbp-p', p.toFixed(3));
    });
  }
  function anstossen() { if (!tickt) { tickt = true; requestAnimationFrame(takt); } }
  if (tiefe.length || fortschritt.length) {
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen);
    takt();
  }

  /* 5 Scroll-Geschichte: die Aufgabe in Bildmitte schaltet die Buehne um.
        Mit data-wbp-kamera (Kombination D+E) faehrt zusaetzlich eine Kamera in den Abschnitt der
        Lagekarte: Zoom und Ausschnitt aus data-kx/ky/kz, am Kartenrand begrenzt. Nur ab 990 px und
        nie bei reduzierter Bewegung; sonst bleibt die Gesamtansicht stehen. */
  var breitGenug = window.matchMedia('(min-width: 990px)');
  alle('[data-wbp-scrolly]').forEach(function (box) {
    var schritte = alle('[data-wbp-schritt]', box);
    var bilder = alle('[data-wbp-buehnenbild]', box);
    var zaehler = box.querySelector('[data-wbp-zaehler]');
    var kamera = box.hasAttribute('data-wbp-kamera') ? box.querySelector('[data-wbp-kamerabild]') : null;
    var kTitel = box.querySelector('[data-wbp-kameratitel]');
    var punkte = alle('[data-wbp-punkt]', box);
    var aktuell = -1;
    box.style.setProperty('--n', schritte.length);
    function fahre(i) {
      if (!kamera) return;
      var s = schritte[i];
      var z = parseFloat(String(s.getAttribute('data-kz') || '1').replace(',', '.')) || 1;
      if (ruhig || !breitGenug.matches || z <= 1) { kamera.style.removeProperty('--wbp-kamera'); kamera.style.setProperty('--z', 1); return; }
      var x = parseFloat(s.getAttribute('data-kx')) || 50, y = parseFloat(s.getAttribute('data-ky')) || 50;
      var tx = klemme(50 - x * z, (1 - z) * 100, 0), ty = klemme(50 - y * z, (1 - z) * 100, 0);
      kamera.style.setProperty('--wbp-kamera', 'translate(' + tx.toFixed(2) + '%, ' + ty.toFixed(2) + '%) scale(' + z + ')');
      kamera.style.setProperty('--z', z);
    }
    function aktiviere(i) {
      if (i < 0 || i === aktuell) return;
      aktuell = i;
      schritte.forEach(function (s, k) { s.classList.toggle('ist-aktiv', k === i); });
      bilder.forEach(function (b, k) { b.classList.toggle('ist-aktiv', k === i); });
      punkte.forEach(function (p, k) { p.classList.toggle('ist-aktiv', k === i); });
      if (zaehler) zaehler.textContent = String(i + 1).padStart(2, '0');
      box.style.setProperty('--wbp-schritt', i);
      if (kamera) {
        box.setAttribute('data-aktiv', String(i + 1));
        if (kTitel) { kTitel.textContent = schritte[i].getAttribute('data-titel') || ''; kTitel.classList.remove('wbp-wechsel'); void kTitel.offsetWidth; kTitel.classList.add('wbp-wechsel'); }
        fahre(i);
      }
    }
    if (kamera) {
      box.style.setProperty('--wbp-schritt', 0);
      breitGenug.addEventListener && breitGenug.addEventListener('change', function () { if (aktuell >= 0) fahre(aktuell); });
    }
    if (!hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) aktiviere(schritte.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    schritte.forEach(function (s) { io.observe(s); });
  });

  /* 6 Reiter (Lagekarte): Punkte auf der Karte und Reiterleiste steuern dieselben Panels.
     Ohne JS stehen alle Panels untereinander, die Reiter sind Sprunglinks. */
  alle('[data-wbp-tabs]').forEach(function (box) {
    var panels = alle('[data-wbp-panel]', box);
    var ausloeser = alle('[data-wbp-tab]', box);
    var leiste = box.querySelector('[data-wbp-tableiste]');
    if (!panels.length) return;
    box.classList.add('wbp-tabs-an');
    if (leiste) leiste.setAttribute('role', 'tablist');
    var leistenTabs = leiste ? alle('[data-wbp-tab]', leiste) : [];
    leistenTabs.forEach(function (t) {
      var i = parseInt(t.getAttribute('data-wbp-tab'), 10);
      t.setAttribute('role', 'tab');
      t.setAttribute('aria-controls', panels[i] && panels[i].id);
      if (t.parentElement) t.parentElement.setAttribute('role', 'presentation');
    });
    panels.forEach(function (p) { p.setAttribute('role', 'tabpanel'); p.setAttribute('tabindex', '-1'); });
    function waehle(i, fokus, vonKarte) {
      ausloeser.forEach(function (t) {
        var an = parseInt(t.getAttribute('data-wbp-tab'), 10) === i;
        t.classList.toggle('ist-aktiv', an);
        if (t.getAttribute('role') === 'tab') { t.setAttribute('aria-selected', an ? 'true' : 'false'); t.setAttribute('tabindex', an ? '0' : '-1'); }
        else t.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
      panels.forEach(function (p, k) {
        var an = k === i;
        p.hidden = !an;
        p.classList.remove('wbp-wechsel');
        if (an) { void p.offsetWidth; p.classList.add('wbp-wechsel'); }
      });
      box.setAttribute('data-aktiv', String(i + 1));
      if (fokus) { var t = leistenTabs[i]; if (t) t.focus(); }
      /* Auf schmalen Schirmen nach Klick auf die Karte zum Panel scrollen */
      if (vonKarte && window.innerWidth < 1100) {
        var ziel = leiste || panels[i];
        var y = ziel.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: ruhig ? 'auto' : 'smooth' });
      }
    }
    ausloeser.forEach(function (t) {
      var i = parseInt(t.getAttribute('data-wbp-tab'), 10);
      t.addEventListener('click', function (ev) { ev.preventDefault(); waehle(i, false, !leiste || !leiste.contains(t)); });
    });
    leistenTabs.forEach(function (t, k) {
      t.addEventListener('keydown', function (ev) {
        var n = null, m = leistenTabs.length;
        if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') n = (k + 1) % m;
        if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') n = (k - 1 + m) % m;
        if (ev.key === 'Home') n = 0;
        if (ev.key === 'End') n = m - 1;
        if (n !== null) { ev.preventDefault(); waehle(n, true, false); }
      });
    });
    var start = 0;
    if (location.hash) panels.forEach(function (p, k) { if ('#' + p.id === location.hash) start = k; });
    waehle(start, false, false);
  });

  /* 7 Fahrzeug faehrt die Wetline ab (SVG, nur im Bild, nie bei reduzierter Bewegung).
        Der helle Schein der Wetline waechst hinter dem Fahrzeug mit; Ruhezustand: voll. */
  alle('[data-wbp-fahrzeug]').forEach(function (fz) {
    if (ruhig || !hatIO) return;
    var svg = fz.ownerSVGElement;
    var pfad = svg && svg.querySelector('#wbp-e-wetline-pfad');
    var schein = svg && svg.querySelector('#wbp-e-wetline-schein');
    if (!pfad || !pfad.getTotalLength) return;
    var laenge = pfad.getTotalLength();
    var dauer = 12000, t0 = null, laeuft = false;
    var ausgang = fz.getAttribute('transform');
    function bild(t) {
      if (!laeuft) return;
      if (!t0) t0 = t;
      var p = ((t - t0) % dauer) / dauer;
      var s = p * laenge;
      var a = pfad.getPointAtLength(s);
      var b = pfad.getPointAtLength(Math.min(s + 2, laenge));
      var w = Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
      fz.setAttribute('transform', 'translate(' + a.x.toFixed(1) + ' ' + (a.y + 22).toFixed(1) + ') rotate(' + w.toFixed(1) + ')');
      if (schein) schein.style.strokeDasharray = (p * 1000).toFixed(1) + ' 1000';
      requestAnimationFrame(bild);
    }
    var buehne = svg.closest('[data-wbp-sicht]') || svg;
    new IntersectionObserver(function (e) {
      if (e[0].isIntersecting && !document.hidden) { if (!laeuft) { laeuft = true; t0 = null; requestAnimationFrame(bild); } }
      else if (laeuft) { laeuft = false; fz.setAttribute('transform', ausgang); if (schein) schein.style.strokeDasharray = ''; }
    }, { threshold: 0.1 }).observe(buehne);
  });

  /* 8 Licht auf Karten, das dem Zeiger folgt */
  if (feinzeiger && !ruhig) {
    document.addEventListener('pointermove', function (ev) {
      var k = ev.target.closest && ev.target.closest('.wbp-karte,[data-wbp-licht]');
      if (!k) return;
      var r = k.getBoundingClientRect();
      k.style.setProperty('--mx', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      k.style.setProperty('--my', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* 9 Spruehnebel und Funken auf der Buehne (rein dekorativ) */
  alle('canvas[data-wbp-nebel]').forEach(function (cv) {
    if (ruhig || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var quellen = (cv.getAttribute('data-wbp-nebel') || '50,104').split(';').map(function (q) {
      var p = q.split(','); return { x: parseFloat(p[0]) / 100, y: parseFloat(p[1]) / 100 };
    });
    var mitFunken = cv.getAttribute('data-wbp-funken') === '1';
    var teile = [], funken = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), laeuft = false, zuletzt = 0;
    function groesse() {
      var r = cv.getBoundingClientRect();
      w = r.width; h = r.height;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function neu() {
      var q = quellen[Math.floor(Math.random() * quellen.length)];
      var a = -Math.PI / 2 + (Math.random() - 0.5) * 1.5;
      var v = (0.5 + Math.random() * 1.2) * Math.max(h, 320) / 560;
      return { x: q.x * w + (Math.random() - 0.5) * 60, y: q.y * h, vx: Math.cos(a) * v, vy: Math.sin(a) * v, r: 1.5 + Math.random() * 3, leben: 0, max: 90 + Math.random() * 110 };
    }
    function funke() {
      return { x: Math.random() * w, y: h + 10, vx: (Math.random() - 0.3) * 0.6, vy: -(0.6 + Math.random() * 1.3), r: 0.8 + Math.random() * 1.6, leben: 0, max: 120 + Math.random() * 160, phase: Math.random() * 6.28 };
    }
    function bild(t) {
      if (!laeuft) return;
      var dt = Math.min((t - zuletzt) / 16.7, 3); zuletzt = t;
      var soll = Math.round(quellen.length * 30 * (w < 750 ? 0.6 : 1));
      while (teile.length < soll) teile.push(neu());
      var fsoll = mitFunken ? (w < 750 ? 10 : 22) : 0;
      while (funken.length < fsoll) funken.push(funke());
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < teile.length; i++) {
        var p = teile[i];
        p.leben += dt; p.x += p.vx * dt; p.y += p.vy * dt; p.vx *= 0.993; p.vy *= 0.993; p.r += 0.06 * dt;
        var k = p.leben / p.max;
        if (k >= 1) { teile[i] = neu(); continue; }
        var alpha = Math.sin(k * Math.PI) * 0.16;
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
        g.addColorStop(0, 'rgba(225,240,245,' + alpha.toFixed(3) + ')');
        g.addColorStop(1, 'rgba(225,240,245,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, Math.PI * 2); ctx.fill();
      }
      for (var j = 0; j < funken.length; j++) {
        var f = funken[j];
        f.leben += dt; f.x += (f.vx + Math.sin(f.leben / 18 + f.phase) * 0.35) * dt; f.y += f.vy * dt;
        var kf = f.leben / f.max;
        if (kf >= 1 || f.y < -10) { funken[j] = funke(); continue; }
        var af = Math.sin(kf * Math.PI) * (0.55 + 0.45 * Math.sin(f.leben / 4));
        ctx.fillStyle = 'rgba(245,215,0,' + Math.max(af, 0).toFixed(3) + ')';
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
      requestAnimationFrame(bild);
    }
    function start() { if (laeuft) return; laeuft = true; zuletzt = performance.now(); requestAnimationFrame(bild); }
    function stopp() { laeuft = false; }
    groesse();
    window.addEventListener('resize', groesse);
    if (hatIO) {
      new IntersectionObserver(function (e) { e[0].isIntersecting && !document.hidden ? start() : stopp(); }, { threshold: 0 }).observe(cv);
    } else { start(); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stopp(); });
  });

  /* 10 Videos: stumm, Schleife, nur im Bild. Ohne JS/bei reduzierter Bewegung: Bedienleiste. */
  alle('video[data-wbp-video]').forEach(function (v) {
    if (ruhig || !hatIO) return;
    v.removeAttribute('controls');
    v.muted = true;
    var film = v.closest('.wbp-film');
    new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) {
        if (v.preload !== 'auto') v.preload = 'auto';
        var p = v.play(); if (p && p.catch) p.catch(function (f) { if (f && f.name === 'NotAllowedError') v.setAttribute('controls', ''); });
        if (film) film.classList.add('wbp-laeuft');
      } else { v.pause(); if (film) film.classList.remove('wbp-laeuft'); }
    }, { threshold: 0.35 }).observe(v);
  });

  /* 11 Anfrage vorbefuellen: Links mit data-wbp-betreff schreiben ins Nachrichtenfeld,
        solange es leer ist oder nur eine fruehere Vorbefuellung traegt. */
  var vorbefuellt = '';
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-wbp-betreff]');
    if (!a) return;
    var text = a.getAttribute('data-wbp-betreff');
    var feld = document.getElementById('AngebotForm-nachricht');
    if (!text || !feld) return;
    if (feld.value.trim() === '' || feld.value === vorbefuellt) {
      feld.value = text; vorbefuellt = text;
      feld.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  /* 12 Schutzlinien-Rechner */
  alle('[data-wbp-rechner]').forEach(function (box) {
    var regler = box.querySelector('[data-wbp-r="regler"]');
    if (!regler) return;
    var abstand = parseFloat(box.getAttribute('data-abstand')) || 12;
    var kreis = parseFloat(box.getAttribute('data-kreis')) || 28;
    var lmin = parseFloat(box.getAttribute('data-lmin')) || 24;
    var behaelter = parseFloat(box.getAttribute('data-behaelter')) || 7500;
    var setname = box.getAttribute('data-setname') || 'Kreisregner-Set';
    var sets = (box.getAttribute('data-sets') || '').split(';').filter(Boolean).map(function (s) {
      var t = s.split(':'); return { n: parseInt(t[0], 10), preis: parseInt(t[1], 10) / 100 };
    }).sort(function (a, b) { return a.n - b.n; });
    function feld(name) { return box.querySelector('[data-wbp-r="' + name + '"]'); }
    function linie(n) { return (n - 1) * abstand + kreis; }
    function plane(laenge) {
      var bedarf = Math.max(3, Math.ceil((laenge - kreis) / abstand - 1e-9) + 1);
      var best = null;
      /* alle Kombinationen bis 8 Boxen: wenigste Boxen, dann niedrigster Preis, dann wenig Ueberhang */
      function suche(i, rest, wahl) {
        if (i === sets.length) {
          var n = 0, preis = 0, boxen = 0;
          wahl.forEach(function (c, k) { n += c * sets[k].n; preis += c * sets[k].preis; boxen += c; });
          if (n < bedarf || boxen === 0) return;
          var kand = { n: n, preis: preis, boxen: boxen, wahl: wahl.slice() };
          if (!best || boxen < best.boxen || (boxen === best.boxen && (preis < best.preis - 0.005 || (Math.abs(preis - best.preis) < 0.005 && n < best.n)))) best = kand;
          return;
        }
        for (var c = 0; c <= rest; c++) { wahl[i] = c; suche(i + 1, rest - c, wahl); }
        wahl[i] = 0;
      }
      if (sets.length) suche(0, 8, sets.map(function () { return 0; }));
      return { bedarf: bedarf, plan: best };
    }
    function planText(pl) {
      if (!pl) return '';
      var teile = [];
      pl.wahl.forEach(function (c, k) { if (c > 0) teile.push(c + ' × ' + sets[k].n + 'er-Set'); });
      return teile.join(' + ');
    }
    function zeichne(n) {
      var svg = feld('bild');
      if (!svg) return;
      var gesichert = linie(n);
      var m = Math.max(gesichert, 110);
      var s = 560 / m;
      var r = kreis / 2 * s;
      var ns = 'http://www.w3.org/2000/svg';
      alle('.wbp-e-linie-kreis,.wbp-e-linie-regner', svg).forEach(function (c) { c.remove(); });
      var text = svg.querySelector('.wbp-e-linie-text');
      for (var i = 0; i < n; i++) {
        var cx = 40 + r + i * abstand * s;
        var k = document.createElementNS(ns, 'circle');
        k.setAttribute('class', 'wbp-e-linie-kreis'); k.setAttribute('cx', cx.toFixed(1)); k.setAttribute('cy', '96'); k.setAttribute('r', r.toFixed(1));
        svg.insertBefore(k, text);
      }
      for (var j = 0; j < n; j++) {
        var cx2 = 40 + r + j * abstand * s;
        var d = document.createElementNS(ns, 'circle');
        d.setAttribute('class', 'wbp-e-linie-regner'); d.setAttribute('cx', cx2.toFixed(1)); d.setAttribute('cy', '96'); d.setAttribute('r', '6');
        svg.insertBefore(d, text);
      }
      if (text) text.textContent = '≈ ' + gesichert + ' m Schutzlinie';
    }
    function rechne() {
      var laenge = parseInt(regler.value, 10);
      var erg = plane(laenge);
      var pl = erg.plan;
      var n = pl ? pl.n : erg.bedarf;
      var wasser = n * lmin;
      feld('laenge').innerHTML = laenge + '<small>m</small>';
      feld('anzahl').textContent = n;
      feld('linie').textContent = linie(n);
      feld('wasser').textContent = ganz(wasser);
      feld('stunde').textContent = (wasser * 60 / 1000).toLocaleString('de-DE', { maximumFractionDigits: 1 });
      feld('reicht').textContent = ganz(Math.floor(behaelter / wasser));
      if (feld('boxen')) feld('boxen').textContent = pl ? pl.boxen : 1;
      if (pl) {
        if (feld('setname')) feld('setname').textContent = planText(pl);
        if (feld('preis')) feld('preis').textContent = euro(pl.preis);
      }
      var anfrage = feld('anfrage');
      if (anfrage) anfrage.setAttribute('data-wbp-betreff', 'Schutzlinie ca. ' + laenge + ' m: ' + n + ' Kreisregner (' + setname + ', ' + planText(pl) + '). Bitte Angebot erstellen.');
      regler.setAttribute('aria-valuetext', laenge + ' Meter, ' + n + ' Kreisregner');
      zeichne(n);
    }
    regler.addEventListener('input', rechne);
    rechne();
  });

  /* 13 Warenkorb ohne Seitenwechsel: Dawn-Schublade befuellen und oeffnen.
        Ohne JS oder ohne Schublade schickt das Formular normal an /cart/add. */
  alle('form[data-wbp-kauf]').forEach(function (form) {
    var wahl = form.querySelector('[data-wbp-variante]');
    var preisEl = form.closest('.wbp-f-stufe__fuss') && form.closest('.wbp-f-stufe__fuss').querySelector('[data-wbp-preis]');
    if (wahl && preisEl) {
      wahl.addEventListener('change', function () {
        var opt = wahl.options[wahl.selectedIndex];
        if (opt && opt.getAttribute('data-preis')) preisEl.innerHTML = opt.getAttribute('data-preis') + '<small>netto</small>';
      });
    }
    form.addEventListener('submit', function (ev) {
      var schublade = document.querySelector('cart-drawer');
      if (!schublade || typeof schublade.renderContents !== 'function' || !window.fetch) return;
      ev.preventDefault();
      var knopf = form.querySelector('button[type="submit"]');
      var label = knopf && knopf.querySelector('span');
      var alt = label ? label.textContent : '';
      if (knopf) { knopf.setAttribute('aria-busy', 'true'); knopf.disabled = true; }
      if (label) label.textContent = 'Wird hinzugefügt …';
      var daten = new FormData(form);
      /* Wie Dawns product-form: die Schublade nennt ihre Sections selbst (b4c ueberschreibt sie) */
      var sektionen = typeof schublade.getSectionsToRender === 'function' ? schublade.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-drawer', 'cart-icon-bubble'];
      daten.append('sections', sektionen.join(','));
      daten.append('sections_url', window.location.pathname);
      var ziel = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      var hinzugefuegt = false;
      var alterHinweis = form.querySelector('.wbp-f-hinweis');
      if (alterHinweis) alterHinweis.remove();
      fetch(ziel, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: daten })
        .then(function (r) { return r.json(); })
        .then(function (antwort) {
          if (antwort.status) {
            /* Shop lehnt ab (z. B. nicht verfuegbar): Hinweis mit Anfrageweg statt Fehlerseite */
            var p = document.createElement('p');
            p.className = 'wbp-f-hinweis'; p.setAttribute('role', 'alert');
            p.innerHTML = (antwort.description || 'Gerade nicht bestellbar.') + ' <a href="#ContactForm">Angebot anfordern</a>';
            form.appendChild(p);
            if (label) label.textContent = alt;
            return;
          }
          hinzugefuegt = true;
          try {
            schublade.classList.remove('is-empty');
            schublade.renderContents(antwort);
          } catch (fehler) {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (label) label.textContent = 'Im Warenkorb';
          if (knopf) knopf.classList.add('ist-im-korb');
          setTimeout(function () { if (label) label.textContent = alt; if (knopf) knopf.classList.remove('ist-im-korb'); }, 2600);
        })
        .catch(function () { if (!hinzugefuegt) form.submit(); else window.location.href = '/cart'; })
        .finally(function () { if (knopf) { knopf.removeAttribute('aria-busy'); knopf.disabled = false; } });
    });
  });

  /* 14 Schwebende Anfrageleiste: nach dem Seitenkopf sichtbar, am Formular weg */
  alle('[data-wbp-sticky]').forEach(function (leiste) {
    if (!hatIO) return;
    var kopf = document.querySelector('.wbp-buehne, .wbp-e-karte');
    var formular = document.getElementById('ContactForm');
    var kopfWeg = false, formDa = false;
    leiste.hidden = false;
    leiste.classList.add('ist-weg');
    function stelle() { leiste.classList.toggle('ist-weg', !(kopfWeg && !formDa)); }
    if (kopf) new IntersectionObserver(function (e) { kopfWeg = !e[0].isIntersecting; stelle(); }, { threshold: 0, rootMargin: '-20% 0px 0px 0px' }).observe(kopf);
    else kopfWeg = true;
    if (formular) new IntersectionObserver(function (e) { formDa = e[0].isIntersecting; stelle(); }, { threshold: 0 }).observe(formular.closest('.shopify-section') || formular);
    stelle();
  });
})();
